import { useQuery } from '@tanstack/react-query';
import { fetchActiveLives, resolveYoutubeLive } from './api.js';

const KEY = ['me', 'streams'] as const;

export function useActiveLives() {
  return useQuery({
    queryKey: KEY,
    queryFn: fetchActiveLives,
    staleTime: 30_000,
    refetchInterval: 30_000,
  });
}

// #144: auto-refresh de viewerCount/title de uma live YouTube anexada. /me/streams
// só traz Twitch, então repollamos /youtube/resolve por videoId a cada 30s.
// `retry: false` deixa um 404 (not_live → live encerrada) virar `error` na hora,
// sinal usado pelo painel pra marcar a live como stale (#147).
export function useYoutubeLiveRefresh(videoId: string | null | undefined) {
  return useQuery({
    queryKey: ['youtube', 'resolve', videoId ?? null],
    queryFn: () => resolveYoutubeLive(videoId as string),
    enabled: !!videoId,
    refetchInterval: 30_000,
    staleTime: 30_000,
    retry: false,
  });
}
